import { doDoorKnock, doWaitImageByTime, isFollowingVanessaLead } from './../helpers/helpers';
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { amber } from "../characters/Amber";
import { empty } from "../characters/empty";
import { mario } from "../characters/Mario";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doTransition } from "../helpers/helpers";
import { images } from "./images";
import { V7ReturningOutfitAfter } from './V7';
import { endReplay } from '../../src/shell/endReplay';
import { replayScenesList } from '../../src/components/menu/Scenes/replayScenes/scenesReplayData';
import SoundClass from '../../src/shell/Sound';
import { music } from './sounds';

export const V7ReturningOutfit = async (): Promise<any> => {
    doTransition(images.v7.AmberMario_11);
    vanessa.talk(`Have you seen this house?`);
    mc.talk(`Yeah, it's pretty big.`);
    ImageClass.setImage(images.v7.AmberMario_15);
    vanessa.talk(`I could have swore he said he's poor!`);
    mc.talk(`He didn't say that.`);
    ImageClass.setImage(images.v7.AmberMario_14);
    vanessa.talk(`So I guess he is just cheap.`);
    vanessa.talk(`With a house like this he should've given you the outfit for free.`);
    ImageClass.setImage(images.v7.AmberMario_13);
    mc.talk(`That's how you become poor.`);
    ImageClass.setImage(images.v7.AmberMario_15);
    vanessa.talk(`Mmm... Yeah, I guess that's true.`);
    ImageClass.setImage(images.v7.AmberMario_13);
    mc.talk(`So...? Are we going to knock or what?`);
    // ImageClass.setImage(images.v7.AmberMario_16);
    vanessa.talk(`Wait, I wanted to talk to you about something.`);
    if (Game.seenScenarios.includes(`V7AnnHouse`)) {
        mc.talk(`Now? Weren't you in a rush?`);
        ImageClass.setImage(images.v7.AmberMario_14);
        vanessa.talk(`Shut up and listen!`);
    } else {

    }

    if (isFollowingVanessaLead()) {
        ImageClass.setImage(images.v7.AmberMario_12);
        vanessa.talk(`I wonder. Does the big guy has a girlfriend or something?`);
        mc.talk(`Are you talking about Mario?`);
        // ImageClass.setImage(images.v7.AmberMario_16);
        vanessa.talk(`Yes, him.`);
        mc.talk(`He does, I saw her in the clothing store. She is kinda hot.`);
        // ImageClass.setImage(images.v7.AmberMario_16);
        vanessa.talk(`Great! You already answered my next question.`);
        mc.talk(`Why does it matter?`);
        vanessa.talk(`Well. It's time for your first lesson!`);
        mc.think(`Oh shit.`);

        vanessa.talk(`You need to get in there with me. And if his girl is in the house, you need to fuck her!`);
        mc.talk(`Are you insane? I don't even know her. Why would she want to fuck me?`);

        ImageClass.setImage(images.v7.AmberMario_15);
        vanessa.talk(`You are handsome so you shouldn't have a problem with that.`);
        mc.talk(`So you expect me to go in there, and fuck Mario's girlfriend while he is still in the house?`);
        mc.talk(`Did you forget what he looks like? He is a fucking brick shithouse; he'd kick my ass.`);

        // ImageClass.setImage(images.v7.AmberMario_16);
        ImageClass.setImage(images.v7.AmberMario_15);
        vanessa.talk(`Don't worry. I'll keep him busy.`);
        mc.talk(`Why am I not surprised.`);

        ImageClass.setImage(images.v7.AmberMario_14);
        vanessa.talk(`Aren't you going to respect your bet?`);
        ImageClass.setImage(images.v7.AmberMario_13);
        mc.talk(`...`);
        mc.talk(`Fuck...`);
        mc.talk(`Fine.`);
        mc.think(`I feel one of us is getting what they want...and it ain't me.`);
        ImageClass.setImage(images.v7.AmberMario_15);
        vanessa.talk(`Great!`);
        mc.talk(`But if something bad happens you need to get me out of that!`);
        vanessa.talk(`Don't worry! It will be fine!`);
        mc.think(`I'm fucked.`);

    } else {
        // ImageClass.setImage(images.v7.AmberMario_16);
        vanessa.talk(`Do you remember our bet?`);
        mc.talk(`It hasn't even been two hours...`);
        ImageClass.setImage(images.v7.AmberMario_12);
        vanessa.talk(`About that... It didn't start already, right?`);
        mc.talk(`Why wouldn't it?`);
        ImageClass.setImage(images.v7.AmberMario_14);
        vanessa.talk(`Fuck!  `);
        ImageClass.setImage(images.v7.AmberMario_15);
        vanessa.talk(`Can we start it tomorrow?`);
        mc.talk(`Vanessa... What are you planning?`);
        ImageClass.setImage(images.v7.AmberMario_14);
        vanessa.talk(`It just hit me that it's been a while since I had sex!`);
        if (Question.globalAnswers.v6HadSexVanessaLivingRoom) {
            mc.talk(`Are you serious? We had sex not long ago.`);
            vanessa.talk(`Exactly. So long ago.`);
        } else if (Question.globalAnswers.v7AteVanessaPussy) {
            mc.talk(`I ate your pussy yesterday.`);
            vanessa.talk(`That's not sex.`);
        } else {
            mc.talk(`When did you have sex?`);
            vanessa.talk(`Not today!`);
        }
        mc.talk(`What are you trying to say?`);
        vanessa.talk(`I'm just asking for one last day of grace.`);
        ImageClass.setImage(images.v7.AmberMario_13);
        mc.talk(`And do what?`);

        ImageClass.setImage(images.v7.AmberMario_15);
        vanessa.talk(`To have a taste of the big guy inside.`);
        mc.talk(`Are you serious?`);
        mc.talk(`He is so pumped he looks like a fucking brick shithouse.`);
        vanessa.talk(`So?`);
        mc.talk(`...`);
        ImageClass.setImage(images.v7.AmberMario_14);
        vanessa.talk(`You do realize that you are the weird one, right?`);
        mc.talk(`I'm not sure about that.`);

        // ImageClass.setImage(images.v7.AmberMario_16);
        vanessa.talk(`So??? What do you say?`);
        mc.talk(`Are you seriously asking me for that?`);
        vanessa.talk(`I respect bets...`);
        mc.talk(`I don't think it matters to you but he has a girlfriend.`);

        ImageClass.setImage(images.v7.AmberMario_15);
        vanessa.talk(`How the fuck do you know that?`);
        mc.talk(`Because I've seen them together at the clothing store when I was with Emily.`);

        vanessa.talk(`Is she hot?`);
        if (Question.globalAnswers.v6EmilyShoppingMadeExcuseToPeepAmber) {
            mc.talk(`She is.`);
            mc.talk(`She also has cute breasts.`);
            vanessa.talk(`Explain.`);
            mc.think(`I'm not going to tell her that I let him peep on Emily while I took a peek at his girl... She already thinks I'm a pervert.`);
            mc.talk(`Well... I won't go into specific, but one thing lead to another and she flashed her breasts when I was looking at her.`);
            vanessa.talk(`Perfect!`);
            vanessa.talk(`So I'll keep him busy while you finish what you started with his girl!`);


        } else {
            mc.talk(`From what I saw. Yes she is.`);
            ImageClass.setImage(images.v7.AmberMario_0);
            vanessa.talk(`Perfect!`);
            vanessa.talk(`So I'll keep him busy while you can go and do whatever with his girl.`);
        }

        mc.talk(`And why the hell do you think he'd want that?`);
        // ImageClass.setImage(images.v7.AmberMario_16);
        vanessa.talk(`He won't remember he has a girlfriend once I'm done with him.`);

        await vanessa.setQuestion(new Question({ text: `Well?`, options: { think: false }, key: `v7VanessaMarioAllowHerFuckMario` })
            .option({ title: `Agree`, key: true })
            .option({ title: `Disagree`, key: false }));


        if (Question.globalAnswers.v7VanessaMarioAllowHerFuckMario) {
            mc.talk(`Alright.`);
            vanessa.talk(`I owe you one!`);
        } else {
            mc.talk(`I'm sorry. A bet is a bet.`);
            ImageClass.setImage(images.v7.AmberMario_14);
            vanessa.talk(`You are no fun at all!`);
            vanessa.talk(`I'm regretting this already.`);
        }

    }

    return jump(V7ReturningOutfit_Inside, "V7ReturningOutfit_Inside");
};
export const V7ReturningOutfit_Inside = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AmberMario_1, { duration: 1 });
    doDoorKnock();
    if (Question.globalAnswers.v7VanessaMarioAllowHerFuckMario || isFollowingVanessaLead()) {
        await mc.set((properties) => {
            properties.v7VanessaFucksMario = true;
        });

        mc.think(`I can't believe I'm doing this.`);
    }
    doWaitImageByTime(images.v7.AmberMario_2);
    mario.talk(`Finally.`);
    ImageClass.setImage(images.v7.AmberMario_3);
    mario.talk(`Hey Bro!`);
    mc.talk(`Hey.`);
    vanessa.talk(`Oh wow. Look at you.`);
    ImageClass.setImage(images.v7.AmberMario_2);
    vanessa.talk(`Were you in the shower?`);
    ImageClass.setImage(images.v7.AmberMario_2.partials.AmberMario_2_p);
    mario.talk(`No. Ha ha.`);
    vanessa.talk(`So why are you in a towel?`);
    mario.talk(`I'm taking care of my girl.`);
    mario.talk(`Get inside, I need to check that you didn't tear the outfit.`);

    if (Question.globalAnswers.v7VanessaMarioAllowHerFuckMario || isFollowingVanessaLead()) {

        return jump(V7ReturningOutfit_VanessaMarioAllowToFuck, "V7ReturningOutfit_VanessaMarioAllowToFuck");

    }

    return jump(V7ReturningOutfit_VanessaMarioDontAllowToFuck, "V7ReturningOutfit_VanessaMarioDontAllowToFuck");
};

export const V7ReturningOutfit_VanessaMarioAllowToFuck = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AmberMario_4, { duration: 1, wait: 1, hideText: true });
    mario.talk(`Wait here.`);
    mario.talk(`I need to go finish her up. Ha ha.`);
    mario.talk(`Keep yourself busy in the meantime.`);

    // FIXME: 
    // vanessa.talk(`You are in a rush...`);
    // mario.talk(`Can't keep my girl waiting for so long! She might finish the job by herself if you know what I mean.`);
    vanessa.talk(`Hold right there big boy.`);
    // vanessa.talk(`She can't wait for a few more seconds...`);
    ImageClass.setImage(images.v7.AmberMario_4.partials.AmberMario_4_p);
    mario.talk(`Ah?`);
    vanessa.talk(`Before you go...`);
    vanessa.talk(`Let me feel those muscles.`);
    ImageClass.setImage(images.v7.AmberMario_4);
    mario.talk(`You like them ah?`);
    vanessa.talk(`I love them!`);
    ImageClass.setImage(images.v7.AmberMario_17, { duration: 1 });
    mario.talk(`There you go.`);
    vanessa.talk(`Oh wow! You are so firm!`);
    ImageClass.setImage(images.v7.AmberMario_18, { duration: 1 });
    vanessa.talk(`And those abs... Wow!`);
    vanessa.talk(`I can't keep my hands off you!`);
    mc.think(`I think this is my cue.`);
    mc.talk(`Ah... Where is the bathroom?`);
    ImageClass.setImage(images.v7.AmberMario_19);
    mario.talk(`Upstairs.`);
    mc.think(`He didn't even look at me.`);
    ImageClass.setImage(images.v7.AmberMario_20, { duration: 1 });
    await vanessa.setQuestion(new Question({ text: `How can girls keep their hands off you big boy?`, options: { think: false }, key: `v7VanessaMarioKeepWatching` })
        .option({ title: `Keep watching`, key: true })
        .option({ title: `Go upstairs`, key: false }));

    if (Question.globalAnswers.v7VanessaMarioKeepWatching) {
        mario.talk(`Ha ha.`);
        vanessa.talk(`I get my muscles from a different kind of exercise.`);
        ImageClass.setImage(images.v7.AmberMario_21, { duration: 1 });
        vanessa.talk(`Here feel them.`);
        vanessa.talk(`What do you think?`);
        mario.talk(`Those are not muscles, that's fat.`);
        vanessa.talk(`Oh... An expert.`);
        ImageClass.setImage(images.v7.AmberMario_22, { duration: 1 });
        vanessa.talk(`Ok, so what about the muscles in my thighs?`);
        ImageClass.setImage(images.v7.AmberMario_23);
        vanessa.talk(`I'm waiting...`);
        ImageClass.setImage(images.v7.AmberMario_25);
        vanessa.talk(`Well?`);
        mario.talk(`They are not bad.`);
        ImageClass.setImage(images.v7.AmberMario_24);
        vanessa.talk(`That's not my thighs.`);
        mario.talk(`I know.`);
        mc.think(`He is under her spell... Now it's my turn to pay his girlfriend a visit.`);
        mario.talk(`Ha ha.`);
    } else {

    }
    return jump(V7ReturningOutfit_McAmber, "V7ReturningOutfit_McAmber");
};
export const V7ReturningOutfit_VanessaMarioDontAllowToFuck = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AmberMario_47, { duration: 1 });
    mario.talk(`Before I check, is there something that I need to know?`);
    vanessa.talk(`Don't you trust me?`);
    ImageClass.setImage(images.v7.AmberMario_49);
    mario.talk(`Ha ha.`);

    mc.think(`Just because I'm not allowing Vanessa to fool around with Mario, doesn't mean that I'm not allowed to fool with his girl...`);
    if (Question.globalAnswers.v6EmilyShoppingMadeExcuseToPeepAmber) {
        mc.think(`She flashed her boobs at the clothing store... She must be into me.`);
    } else {
        mc.think(`She gave me that look before entering the changing booth, she must be into me.`);
    }

    await mc.setQuestion(new Question({ text: `I can make an excuse to go and find her...`, options: { think: true }, key: `V7MadeExcuseToFindAmber` })
        .option({ title: `Make an excuse`, key: true })
        .option({ title: `Don't make an excuse`, key: false }));


    if (Question.globalAnswers.V7MadeExcuseToFindAmber) {
        mc.talk(`Mario, can I use the bathroom?`);
        ImageClass.setImage(images.v7.AmberMario_50);
        mario.talk(`Of course buddy!`);
        mario.talk(`It's upstairs, you can't miss it.`);
        return jump(V7ReturningOutfit_McAmber, "V7ReturningOutfit_McAmber");

    } else {
        mc.think(`Nah, it's not worth it.`);
        ImageClass.setImage(images.v7.AmberMario_48);
        amber.talk(`Honey get your ass up here right now!!!`, { method: "Loud Shouting" });
        ImageClass.setImage(images.v7.AmberMario_49);
        mario.talk(`You are right, I completely trust you.`);
        mario.talk(`I need to take care of business now! Ha ha.`);
        doWaitImageByTime(images.v7.AmberMario_5);
        mario.talk(`See yourselves out.`);
        // TODO: option to go watch them?
    }

    return jump(V7ReturningOutfit_FinishOutside, "V7ReturningOutfit_FinishOutside");
};
export const V7ReturningOutfit_McAmber = async (): Promise<any> => {

    ImageClass.setImage(images.v7.AmberSex_28, { duration: 1 });
    // SoundClass.startMusic(music.V7ReturningOutfit_McAmber, { shouldPlay: true, loop: true });
    await mc.think(`I think this is the bedroom...`);
    await amber.set((properties) => {
        amber.name = "Stranger";
    });
    mc.think(`I know nothing about her... It can go smoothly or creepy as fuck.`);
    if (Question.globalAnswers.v6EmilyShoppingMadeExcuseToPeepAmber) {
        mc.think(`She flashed me at the clothing store without knowing me so she might be happy to see me again...`);
    } else {
    }
    mc.think(`Well... I'm about to find out.`);
    ImageClass.setImage(images.v7.AmberSex_3, { duration: 1.5, wait: 1.5, hideText: true });
    mc.think(`Oh wow.`);
    mc.think(`She is keeping herself busy until Mario gets back.`);
    ImageClass.setImage(images.v7.AmberSex_4, { duration: 1.5 });
    amber.talk(`Ah...`, { method: "Soft Voice" });
    await mc.setQuestion(new Question({ text: `She is so focused on herself... I wonder if I should help her out...`, options: { think: true }, key: `v7ReturningOutfitMcAmberLickHerPussy` })
        .option({ title: `Lick her pussy`, key: true })
        .option({ title: `Leave`, key: false }));


    if (Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy) {

        return jump(V7ReturningOutfit_McAmberInside, "V7ReturningOutfit_McAmberInside");
    }

    // SoundClass.stopMusic(music.V7ReturningOutfit_McAmber);
    return jump(V7ReturningOutfit_McAmberLeft, "V7ReturningOutfit_McAmberLeft");

};
export const V7ReturningOutfit_McAmberInside = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AmberSex_5, { duration: 1 });
    if (Question.globalAnswers.v7AteVanessaPussy) {
        mc.think(`I already licked one pussy today... Why not make it two?`);

    } else {
        mc.think(`Here goes nothing.`);

    }
    ImageClass.setImage(images.v7.Anim_McAmberLick.poster, { duration: 1 });
    amber.talk(`Ah!!!`);
    ImageClass.setAnimation(images.v7.Anim_McAmberLick, { duration: 0 });
    amber.talk(`Babe!`);
    amber.talk(`Don't stop babe!`);
    mc.talk(`Mnnnh. Hmmmmh.`);
    amber.talk(`It's been so long since you went down on me! Fuck!`);
    mc.think(`She thinks I'm Mario...`);
    ImageClass.setImage(images.v7.AmberSex_7);
    mc.think(`Fuck... Now she definitely knows I'm not him.`);
    mc.think(`She isn't saying anything...`);
    mc.think(`......`);
    if (Question.globalAnswers.v6EmilyShoppingMadeExcuseToPeepAmber) {

        mc.think(`I wonder if she recognizes me from the clothing store.`);
    }
    ImageClass.setImage(images.v7.Anim_McAmberLick.poster, { duration: 1, wait: 1, hideText: true });
    ImageClass.setAnimation(images.v7.Anim_McAmberLick, { duration: 0 });
    mc.think(`She laid back fully aware that some random stranger entered her room, and started licking her pussy...`);
    ImageClass.setImage(images.v7.AmberSex_8);
    mc.talk(`Mmm!`);
    mc.think(`She tastes wonderful...`);
    amber.talk(`Ahhh!`);
    mc.think(`Holy shit she became so wet it's like a waterfall.`);
    amber.talk(`Pleassse!`);
    ImageClass.setImage(images.v7.AmberSex_9);
    amber.talk(`Don't stoooop!`);
    amber.talk(`I can't!`);
    ImageClass.setImage(images.v7.AmberSex_10, { duration: 1, wait: 1, hideText: true });
    mc.think(`Without saying anything she guided me to lay on the bed while climbing on top of my face. `);
    mc.think(`I eagerly complied and she started riding my face.`);
    mc.think(`I can't believe she can be so relaxed and take the initiative with a complete stranger.`);
    mc.think(`Maybe this won't end poorly after all.`);
    ImageClass.setImage(images.v7.AmberSex_13, { duration: 1 });
    mc.think(`I took my clothes off and she leaned down into a 69 position and started sucking my dick.`);

    ImageClass.setImage(images.v7.Anim_AmberMCBJ.poster);
    mc.think(`Fuck! Now we are talking!`);
    ImageClass.setAnimation(images.v7.Anim_AmberMCBJ, { duration: 0 });
    mc.think(`Her mouth feels so good.`);
    mc.think(`She definitely has experience.`);
    mc.think(`All I can feel is her tongue rubbing against the tip of my cock...`);
    mc.think(`I'll cum if she doesn't stop!`);
    mc.think(`I need to step up here... and redouble my effort.`);
    ImageClass.setImage(images.v7.AmberSex_16, { duration: 1, wait: 1, hideText: true });
    mc.think(`Fuck, she is really doing that.`);
    return jump(V7ReturningOutfit_McAmberInside_2, "V7ReturningOutfit_McAmberInside_2");
};
export const V7ReturningOutfit_McAmberInside_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v7.Anim_AmberRiding.poster, { duration: 1, wait: 1, hideText: true });
    ImageClass.setAnimation(images.v7.Anim_AmberRiding, { duration: 0 });
    mc.think(`Her pussy is so wet, my dick just slid in.`);
    mc.think(`She started riding my dick. Bouncing up and down.`);
    mc.think(`It feels so nice and tight.`);
    mc.think(`I can't believe I'm fucking a complete stranger.`);
    if (mc.properties.v7VanessaFucksMario) {
        mc.think(`Vanessa wasn't wrong. Damn.`);
        mc.think(`Why am I thinking of Vanessa?!? Get in the game ${mc.name}!`);
    } else {
    }
    mc.think(`There is no way I'm stopping now, at least I'm going to make the most of it.`);
    ImageClass.setImage(images.v7.Anim_AmberMCLayingDoggy.poster, { duration: 1 });
    mc.think(`I turned her around and got on top of her.`);
    ImageClass.setAnimation(images.v7.Anim_AmberMCLayingDoggy, { duration: 0 });
    mc.think(`Damn, her ass is so firm I can feel she works out.`);
    amber.talk(`Ahh...`);
    mc.think(`She is enjoying it.`);
    mc.think(`But I can't keep going, I'm about to cum!`);
    mc.talk(`Fuck!`);
    ImageClass.setImage(images.v7.AmberSex_21, { duration: 0, wait: 1, shake: true });
    mc.talk(`Ahh!!!`, { wait: false });
    ImageClass.setImage(images.v7.AmberSex_22, { duration: 1, wait: true, shake: true });
    mc.think(`I regret nothing.`);
    ImageClass.setImage(images.v7.AmberSex_23, { duration: 1 });
    mc.think(`Well... This is awkward.`);
    mc.think(`I don't even know her name.`);
    mc.talk(`Hey...?`);
    mc.talk(`My name is ${mc.name}.`);
    mc.talk(`Is it too late to ask for your name?`);
    doWaitImageByTime(images.v7.AmberSex_24);
    mc.talk(`Wait what about my...`);
    ImageClass.setImage(images.v7.AmberSex_25, { duration: 0, shake: true });
    mc.talk(`Clothes...`);
    await mc.think(`She kicked me out... Didn't she enjoy it?`);
    doWaitImageByTime(images.v7.AmberSex_26);
    amber.name = "Amber";
    amber.talk(`My name is Amber by the way.`);
    mc.talk(`Thank...`);
    ImageClass.setImage(images.v7.AmberSex_27, { shake: true, duration: 0 });
    mc.talk(`You...`);
    mc.think(`Strange...`);
    mc.think(`At least I have a good story to tell.`);
    await endReplay(replayScenesList.v7AmberSex);
    if (mc.properties.v7VanessaFucksMario) {
        mc.think(`Let's see if Vanessa is done with Mario.`);
    } else {
        mc.think(`Let's see how Vanessa and Mario are doing.`);

    }

    // SoundClass.stopMusic(music.V7ReturningOutfit_McAmber);
    return jump(V7ReturningOutfit_Finish, "V7ReturningOutfit_Finish");
};

export const V7ReturningOutfit_McAmberLeft = async (): Promise<any> => {

    ImageClass.setImage(images.v7.AmberSex_5);
    mc.think(`I can't do this... This is too weird.`);
    mc.talk(`I better leave before she notices me.`);
    await endReplay();

    if (mc.properties.v7VanessaFucksMario) {
        return jump(V7ReturningOutfit_LivingRoomEarlyMarioVanessaFuck, "V7ReturningOutfit_LivingRoomEarlyMarioVanessaFuck");
    } else {

    }
    return jump(V7ReturningOutfit_LivingRoomEarlyMarioVanessaNoFuck, "V7ReturningOutfit_LivingRoomEarlyMarioVanessaNoFuck");
};


export const V7ReturningOutfit_LivingRoomEarlyMarioVanessaFuck = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AmberMario_6, { duration: 1, wait: 1, hideText: true });
    vanessa.talk(`Yes! Yes! Yes!`);
    vanessa.talk(`Harder big boy! Show me what you got!`);
    vanessa.talk(`Come on! Put those muscles to work!`);
    mc.think(`Vanessa is certainly having fun.`);
    mc.think(`Neither one of them cares that his girlfriend might hear them.`);
    ImageClass.setImage(images.v7.AmberMario_9, { duration: 1 });
    mc.think(`Damn... She is looking right at me.`);
    vanessa.talk(`It looks like we have a guest.`);
    mario.talk(`${mc.name}! Come down!`);

    if (Question.globalAnswers.v4StayedWithVanessaAlleyBJ) {
        mc.think(`Well... It's not the first time I'm seeing her fuck some random guy.`);

    } else if (Question.globalAnswers.v4SexTapeAgreeToFilm) {
        mc.think(`Well... It's not the first time I'm seeing her fucking.`);

    }
    ImageClass.setImage(images.v7.AmberMario_7, { duration: 1 });
    mario.talk(`Did you find the bathroom bro?`);
    vanessa.talk(`More fucking less talking!`);
    ImageClass.setImage(images.v7.AmberMario_8);
    vanessa.talk(`Faster! Come on!`);
    mc.think(`Oh shit. He is fucking her in the ass.`);
    if (Question.globalAnswers.v4SexTapeFuckedVanessa) {
        mc.think(`Why did I settles for her pussy? Damn.`);
    } else {
        mc.think(`That's good to know.`);
    }
    ImageClass.setImage(images.v7.AmberMario_7);
    mario.talk(`Bro! Join us.`);
    vanessa.talk(`Nah ah. Not today.`);
    vanessa.talk(`He said he likes it rough but all I'm getting is weak sauce.`);
    ImageClass.setImage(images.v7.AmberMario_10, { duration: 1, wait: 1, hideText: true });
    mario.talk(`Oh yeah?`);
    vanessa.talk(`That's better!`);
    vanessa.talk(`You said girls can't walk once you are done with them. Show me!`);
    ImageClass.setImage(images.v7.AmberMario_26);
    mc.think(`Mario grabbed Vanessa and leaned her on the couch.`);
    ImageClass.setImage(images.v7.AmberMario_27);
    mc.think(`He continued fucking her in the ass as if he meant to drive her through the sofa.`);
    vanessa.talk(`Fuck! That's better!`);
    ImageClass.setImage(images.v7.AmberMario_28);
    vanessa.talk(`Keep going!`);
    await vanessa.setQuestion(new Question({ text: `Does it turn you on?`, options: { think: false }, key: `v7VanessaMarioFuckTurnsOnTheMC` })
        .option({ title: `Yes`, key: true })
        .option({ title: `No`, key: false }));


    if (Question.globalAnswers.v7VanessaMarioFuckTurnsOnTheMC) {
        await mc.set((properties) => {
            properties.vanessaRelationship++;
        });
        mc.talk(`Yes.`);
        vanessa.talk(`I knew it.`);

    } else {
        mc.talk(`No.`);
        vanessa.talk(`Really?`);

    }

    ImageClass.setImage(images.v7.AmberMario_27);
    vanessa.talk(`Ah!`);
    ImageClass.setImage(images.v7.AmberMario_28);
    mario.talk(`I'm cumming!`);
    ImageClass.setImage(images.v7.AmberMario_29);
    vanessa.talk(`Go for it big boy!`);
    // FIXME: try to fix the cum shader 
    ImageClass.setImage(images.v7.AmberMario_30);
    mario.talk(`Ahh!!`);
    vanessa.talk(`Fuck! `);

    doWaitImageByTime(images.v7.AmberMario_37);
    vanessa.talk(`Thank you!`);
    mario.talk(`Thank you! Ha ha.`);
    ImageClass.setImage(images.v7.AmberMario_38, { duration: 0.5, wait: 0.5 });
    ImageClass.setImage(images.v7.AmberMario_39, { duration: 0.5, wait: 0.5 });
    ImageClass.setImage(images.v7.AmberMario_38, { duration: 0.5, wait: 0.5 });
    ImageClass.setImage(images.v7.AmberMario_39, { duration: 0.5, wait: 0.5 });
    vanessa.talk(`We'll get going now.`);
    mario.talk(`Do you want to go again?`);
    vanessa.talk(`No, that's how I shake hands.`);
    vanessa.talk(`Bye!`);
    await endReplay(replayScenesList.v7VanessaMarioOutfit);

    return jump(V7ReturningOutfit_FinishOutside, "V7ReturningOutfit_FinishOutside");
};
export const V7ReturningOutfit_LivingRoomEarlyMarioVanessaNoFuck = async (): Promise<any> => {
    ImageClass.setImage(images.v7.AmberSex_28);
    mc.think(`I believe I made the right choice...`);
    return jump(V7ReturningOutfit_Finish, "V7ReturningOutfit_Finish");
};

export const V7ReturningOutfit_Finish = async (): Promise<any> => {
    if (mc.properties.v7VanessaFucksMario) {
        doWaitImageByTime(images.v7.AmberMario_32);
        mario.talk(`Ha ha, yes and I also did some boxing when I was younger.`);
        vanessa.talk(`Boxing, wow! So interesting.`);
        mario.talk(`All my matches finished in a knockout.`);
        vanessa.talk(`WOW! I can't believe it.`);
        ImageClass.setImage(images.v7.AmberMario_33);
        vanessa.talk(`${mc.name}! Took you a long enough.`);
        mc.talk(`Ah... Yeah, it was number two.`);
        mario.talk(`I hope you lit a candle.`);

    } else {
        doWaitImageByTime(images.v7.AmberMario_34);
        mario.talk(`Nutrition is very important.`);
        mario.talk(`You need to make sure to get the most out of your food.`);
        mario.talk(`Make sure to eat food with a lot of fiber.`);
        mario.talk(`Beans and broccoli can be a good choice.`);
        mario.talk(`Do you want me to write it down for you?`);
        vanessa.talk(`I can remember.`);
        mario.talk(`Are you sure? Do you want me to repeat it so you won't forget?`);
        ImageClass.setImage(images.v7.AmberMario_35);
        vanessa.talk(`${mc.name}! You have no idea how glad I am to see you.`);
        mario.talk(`Hey bro! Took you a long time, I hope you flushed! Ha ha.`);

    }
    mc.talk(`Of course.`);
    vanessa.talk(`Cool, let's go.`);
    ImageClass.setImage(images.v7.AmberMario_36);
    vanessa.talk(`Nice seeing you again! Bye!`);
    if (mc.properties.v7VanessaFucksMario) {
        mario.talk(`Feel free to stop by any time. Ha ha.`);

    } else {
        mario.talk(`Are you sure you don't want my menu?`);
        vanessa.talk(`Byeeeee!`);
    }

    return jump(V7ReturningOutfit_FinishOutside, "V7ReturningOutfit_FinishOutside");
};

export const V7ReturningOutfit_FinishOutside = async (): Promise<any> => {


    // Vanessa bet - Vanessa fucks Mario
    if (isFollowingVanessaLead()) {
        if (Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy) {
            doTransition(images.v7.AmberMario_41);
            vanessa.talk(`Did you do it??`);
            mc.talk(`I did.`);
            ImageClass.setImage(images.v7.AmberMario_42);
            vanessa.talk(`Really?!`);
            mc.talk(`Of course. We agreed I'd follow your lead and I have.`);
            ImageClass.setImage(images.v7.AmberMario_41);
            vanessa.talk(`${mc.name}! I'm impressed!`);
            ImageClass.setImage(images.v7.AmberMario_42);
            vanessa.talk(`I honestly thought you'll get cold feet.`);
            ImageClass.setImage(images.v7.AmberMario_40);
            mc.talk(`It was easier than I thought.`);
            mc.talk(`She was already naked and horny.`);
            ImageClass.setImage(images.v7.AmberMario_42);
            vanessa.talk(`Lucky you!`);
            ImageClass.setImage(images.v7.AmberMario_41);
            vanessa.talk(`Did you enjoy it?`);
            ImageClass.setImage(images.v7.AmberMario_40);
            mc.talk(`I did.`);
            ImageClass.setImage(images.v7.AmberMario_41);
            vanessa.talk(`Great!`);
            ImageClass.setImage(images.v7.AmberMario_42);
            vanessa.talk(`You see! I told you it's fun to be me!`);
            vanessa.talk(`We both got some action today!`);
            ImageClass.setImage(images.v7.AmberMario_42);
            mc.talk(`I guess we have, haha.`);
            mc.talk(`How was it for you?`);
            vanessa.talk(`It was nice.`);
            mc.talk(`Only nice?`);
            vanessa.talk(`Yeah, I thought he'd be rougher.`);
            mc.talk(`Oh.`);
            vanessa.talk(`But I still enjoyed it!`);
            mc.talk(`That's all it matters right?`);
            vanessa.talk(`Right.`);


        } else {
            doTransition(images.v7.AmberMario_40);
            vanessa.talk(`I guess you got cold feet.`);
            mc.talk(`...`);
            ImageClass.setImage(images.v7.AmberMario_43);
            vanessa.talk(`What the fuck ${mc.name}?! We have a bet!`);
            mc.talk(`I guess I lost.`);
            ImageClass.setImage(images.v7.AmberMario_45);
            vanessa.talk(`Oh no! No way I'm letting you off that easy.`);
            ImageClass.setImage(images.v7.AmberMario_43);
            vanessa.talk(`Next time you'd better do as I say!`);
            ImageClass.setImage(images.v7.AmberMario_40);
            mc.talk(`I just couldn't do it. It was creepy as fuck.`);
            mc.talk(`She was masturbating naked on the bed waiting for Mario.`);
            ImageClass.setImage(images.v7.AmberMario_46);
            vanessa.talk(`Oh my God! That was the best opportunity!`);
            mc.talk(`To be a creep, sure.`);
            ImageClass.setImage(images.v7.AmberMario_42);
            vanessa.talk(`You know nothing!`);
            vanessa.talk(`It's one of the biggest fantasies for a girl, to have someone go down on them while they masturbate.`);
            ImageClass.setImage(images.v7.AmberMario_40);
            mc.talk(`Of course, maybe if that's someone they know.`);
            mc.talk(`But a complete stranger?`);
            mc.talk(`I think you are watching too much porn.`);
            ImageClass.setImage(images.v7.AmberMario_42);
            vanessa.talk(`You are so dumb!`);
        }


    } else {
        if (Question.globalAnswers.v7VanessaMarioAllowHerFuckMario) {
            doTransition(images.v7.AmberMario_40);
            if (Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy) {
                mc.talk(`So?`);
                ImageClass.setImage(images.v7.AmberMario_42);
                vanessa.talk(`So?`);
                ImageClass.setImage(images.v7.AmberMario_40);
                mc.talk(`Did you fuck Mario?`);
                vanessa.talk(`I fucked him all right!`);
                mc.talk(`Does that mean you are relaxed now?`);
                ImageClass.setImage(images.v7.AmberMario_46);
                vanessa.talk(`Yeah, I'm good for a couple of hours.`);
                mc.talk(`Couple of hours? What the fuck?!`);
                ImageClass.setImage(images.v7.AmberMario_40);
                vanessa.talk(`Don't worry! I won't do anything without asking you first...`);
                mc.talk(`Just don't call me in the middle of the night.`);
                ImageClass.setImage(images.v7.AmberMario_45);
                vanessa.talk(`Fuck.`);

            } else {

                mc.talk(`Did you get it all out of your system now?`);
                ImageClass.setImage(images.v7.AmberMario_41);
                vanessa.talk(`There is always room for more, but I'm good for now!`);
                ImageClass.setImage(images.v7.AmberMario_40);
                mc.talk(`Anal huh?`);
                ImageClass.setImage(images.v7.AmberMario_42);
                vanessa.talk(`What can I say? I realized you're going to cut off sex from me and the big guy likes asses.`);
                vanessa.talk(`So I went all out!`);
                if (Question.globalAnswers.v6HadSexVanessaLivingRoom) {
                    ImageClass.setImage(images.v7.AmberMario_40);
                    mc.talk(`So you are telling me I could've stuck it up your ass as well?`);
                    ImageClass.setImage(images.v7.AmberMario_46);
                    vanessa.talk(`Depends on my mood. But you could've tried.`);
                    ImageClass.setImage(images.v7.AmberMario_41);
                    vanessa.talk(`Tough luck! Now I'm an innocent little girl.`);
                    mc.talk(`Sure...`);
                } else {

                }
            }


        } else {
            doTransition(images.v7.AmberMario_43);
            if (Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy) {
                vanessa.talk(`What really happened up there?!`);
                vanessa.talk(`I know you didn't take a shit!`);
                ImageClass.setImage(images.v7.AmberMario_45);
                vanessa.talk(`I had to listen to him talking about his fucking diet for I don't know how long!`);
                mc.think(`I can't tell her what really happened, she'd kill me.`);
                ImageClass.setImage(images.v7.AmberMario_40);
                mc.talk(`It was the truth.`);
                ImageClass.setImage(images.v7.AmberMario_42);
                vanessa.talk(`Rrrrright.`);


            } else {

                vanessa.talk(`So that was boring...`);
                ImageClass.setImage(images.v7.AmberMario_40);
                mc.talk(`We came in to return the outfit and that's what we did.`);
                ImageClass.setImage(images.v7.AmberMario_45);
                vanessa.talk(`B-O-R-I-N-G!`);

            }
            mc.talk(`By the way, I'm proud of you!`);
            ImageClass.setImage(images.v7.AmberMario_46);
            mc.talk(`I honestly didn't believe you'd respect our bet.`);
            ImageClass.setImage(images.v7.AmberMario_40);
            vanessa.talk(`That's a line I never cross.`);
            mc.talk(`Good to know.`);
            ImageClass.setImage(images.v7.AmberMario_43);
            vanessa.talk(`But try to get it more interesting next time! Like what the fuck.`);
            mc.talk(`Ok, I'll try.`);

        }

    }


    return jump(V7ReturningOutfitAfter, "V7ReturningOutfitAfter");
};